var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_vm._v("\n  p:"+_vm._s(_vm.params)+"\n  q:"+_vm._s(_vm.query)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }